module.exports = __webpack_public_path__ + "static/media/fly0151.63630c88.webp";